import { FirebaseActions, FirebaseSelectors } from '@web_opxp/features';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action, Dispatch } from 'redux';
import { getObFlowConfig, shouldShow, triggerShow } from './utils';

export default function useExperimentControl(): [
  started: boolean,
  showBanner: boolean,
  showBridge: boolean,
  triggerBannerShown: () => void,
  triggerBridgeShown: () => void,
] {
  const dispatch = useDispatch<Dispatch<Action<string>>>();
  const ready = useSelector(FirebaseSelectors.isReady);
  const obFlowConfig = ready ? getObFlowConfig() : undefined;

  useEffect(() => {
    if (!obFlowConfig || !obFlowConfig.variant) {
      return;
    }
    // track experiment as soon as its loaded
    dispatch(FirebaseActions.setUserPropertyAction('experiment_6673', obFlowConfig.variant));
  }, [dispatch, obFlowConfig]);

  const [showBanner, setShowBanner] = useState(false);
  const [showBridge, setShowBridge] = useState(false);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    if (!obFlowConfig) {
      return;
    }
    let shouldShowBanner = false;
    if (obFlowConfig.med_subscribe_banner) {
      // set initial value for banner
      try {
        shouldShowBanner = shouldShow(
          'med_subscribe_banner',
          obFlowConfig.med_subscribe_banner_times,
          obFlowConfig.med_subscribe_banner_delay
        );
        setShowBanner(shouldShowBanner);
        if (shouldShowBanner) {
          triggerShow('med_subscribe_banner');
        }
      } catch {
        // ignore errors
      }
    }
    if (obFlowConfig.med_subscribe_followup) {
      // set initial value
      try {
        const shouldShowBridge = shouldShow(
          'med_subscribe_followup',
          obFlowConfig.med_subscribe_followup_times,
          obFlowConfig.med_subscribe_followup_delay
        );
        // bridge must be shown only together with banner
        setShowBridge(shouldShowBridge && shouldShowBanner);
      } catch {
        // ignore errors
      }
    }
    setStarted(true);
  }, [obFlowConfig]);

  const bannerShown = () => {
    triggerShow('med_subscribe_banner');
  };

  const bridgeShown = () => {
    if (!obFlowConfig) {
      return;
    }
    triggerShow('med_subscribe_followup');
    setShowBridge(
      shouldShow(
        'med_subscribe_followup',
        obFlowConfig.med_subscribe_followup_times,
        obFlowConfig.med_subscribe_followup_delay
      )
    );
  };
  return [started, showBanner, showBridge, bannerShown, bridgeShown];
}
